import { Utils } from '../../../../utils/common'
import { logger } from '../../../../utils/common/logger'
import { Store } from '../../../../utils/storage/keys'
import { LoginService } from '../loginradius/services/login-service'
import { IdentityPagesAPI } from './pages-api'

export class VerifyPasswordless {
    public static DOM = {
        class: {
            pageVerifyPasswordless: 'page-verify-passwordless'
        }
    }

    private tokenQueryStringKey = 'vtoken'

    private redirectQueryStringKey = 'redirect'

    /**
     * Verifies the access token. If token is valid, redirect to the SSO page
     */
    public async init() {
        const verifyPasswordlessPage = document.querySelector(`.${VerifyPasswordless.DOM.class.pageVerifyPasswordless}`)
        const urlParams = Utils.urlParams(document.location)

        if (verifyPasswordlessPage) {
            if (urlParams.has(this.tokenQueryStringKey)) {
                const token = urlParams.get(this.tokenQueryStringKey)
                // check if the token is valid
                try {
                    const response = await IdentityPagesAPI.verifyPasswordlessLogin({ vtoken: token })

                    const accessToken = response.access_token

                    if (accessToken) {
                        if (sessionStorage && localStorage) {
                            localStorage.setItem(Store.LR_TOKEN_KEY, accessToken)
                            let redirect = urlParams.has(this.redirectQueryStringKey) ?
                                                urlParams.get(this.redirectQueryStringKey) : location.origin

                            // Clear any stored redirects because we have the one from the URL
                            LoginService.clearRedirectUrl()
                            const redirectURLObj = new URL(redirect)
                            const isMobile = LoginService.isMobileRedirect(redirect)
                            if (!isMobile && (location.hostname !== redirectURLObj.hostname)) {
                                // redirect url domain does not match with site domain
                                redirect = location.origin
                            } else if(isMobile) {
                                // If it's a redirect to the mobile app, then
                                // we need to include the auth token in the redirection.
                                redirect = LoginService.addMobileRedirectTokenToUrl(redirect, accessToken)
                            }

                            this.setSessionStorage(urlParams)
                            logger('debug', 'Verify passwordless email link success')

                            sessionStorage.removeItem(Store.PASSWORDLESS_EMAIL_ADDRESS)

                            // Redirect to SSO page that will later redirect the user to the `redirect`
                            location.replace(LoginService.getSSORedirectURL(accessToken, redirect))
                        }
                    } else {
                        logger('error', 'Passwordless email link is invalid')
                        location.replace('/verify-passwordless-error/')
                    }
                } catch(err) {
                    logger('error', 'Unable to verify passwordless email link', err)
                    location.replace('/verify-passwordless-error/')
                }
            } else {
                logger('error', 'Missing vtoken parameter in passwordless email link')
                location.replace('/verify-passwordless-error/')
            }
        }
    }

    /**
     * Sets session storage keys
     *
     * @param urlParams
     */
    private setSessionStorage(urlParams: URLSearchParams) {
        const sessionStorageKeys = [
            Store.CAMPAIGN,
            Store.CAMPAIGN_NAME,
            Store.OFFER_GROUP,
            Store.PIANO_PARAMS
        ] // url params that we want to add to session storage

        sessionStorageKeys.map((key) => {
            if (urlParams.has(key)) {
                sessionStorage.setItem(key, urlParams.get(key))
            }
        })

        // set redirect url session storage key
        if (urlParams.has(Store.PIANO_PARAMS) && urlParams.get(this.redirectQueryStringKey)) {
            LoginService.setRedirectUrl(urlParams.get(this.redirectQueryStringKey))
        }
    }
}
